import { Layout } from 'components'
import { CurrentUserContextProvider } from 'context'
import { ManagerDashboardProvider } from './context/ManagerDashboardContext'
import { ManagerDashboardContent } from './ManagerDashboardContent'

/** Temporary dashboard for migrated managers (Arc). Entry point + providers. */
export const ManagerDashboardPage = () => {
  return (
    <CurrentUserContextProvider>
      <Layout>
        <ManagerDashboardProvider>
          <ManagerDashboardContent />
        </ManagerDashboardProvider>
      </Layout>
    </CurrentUserContextProvider>
  )
}
